// This file is generated by Style Dictionary
const tokens = {
  banner: '0.0px 3.0px 16.0px 0px rgba(0, 0, 0, 0.05),0.0px 9.0px 12.0px 0px rgba(0, 0, 0, 0.05)',
  bottomSheet:
    '0.0px 6.0px 30.0px 0px rgba(0, 0, 0, 0.05),0.0px 16.0px 24.0px 0px rgba(0, 0, 0, 0.05)',
  containedButtonRaised:
    '0.0px 3.0px 16.0px 0px rgba(0, 0, 0, 0.05),0.0px 9.0px 12.0px 0px rgba(0, 0, 0, 0.05)',
  containedButtonResting:
    '0.0px 4.0px 10.0px 0px rgba(0, 0, 0, 0.05),0.0px 2.0px 6.0px 0px rgba(0, 0, 0, 0.05)',
  containedInteractionRaised:
    '0.0px 3.0px 16.0px 0px rgba(0, 0, 0, 0.05),0.0px 9.0px 12.0px 0px rgba(0, 0, 0, 0.05)',
  containedInteractionResting: '0.0px 0.0px 0.0px 0px rgba(0, 0, 0, 0)',
  dialog: '0.0px 9.0px 46.0px 0px rgba(0, 0, 0, 0.05),0.0px 24.0px 38.0px 0px rgba(0, 0, 0, 0.05)',
  fabRaised:
    '0.0px 5.0px 22.0px 0px rgba(0, 0, 0, 0.05),0.0px 12.0px 17.0px 0px rgba(0, 0, 0, 0.05)',
  fabResting:
    '0.0px 3.0px 14.0px 0px rgba(0, 0, 0, 0.05),0.0px 6.0px 10.0px 0px rgba(0, 0, 0, 0.05)',
  galleryCard:
    '0.0px 3.0px 16.0px 0px rgba(0, 0, 0, 0.05),0.0px 9.0px 12.0px 0px rgba(0, 0, 0, 0.05)',
  menu: '0.0px 3.0px 16.0px 0px rgba(0, 0, 0, 0.05),0.0px 9.0px 12.0px 0px rgba(0, 0, 0, 0.05)',
  modalDrawer:
    '0.0px 6.0px 30.0px 0px rgba(0, 0, 0, 0.05),0.0px 16.0px 24.0px 0px rgba(0, 0, 0, 0.05)',
  snackbar: '0.0px 3.0px 14.0px 0px rgba(0, 0, 0, 0.05),0.0px 6.0px 10.0px 0px rgba(0, 0, 0, 0.05)',
  switch: '0.0px 2.0px 2.0px 0px rgba(0, 0, 0, 0.05),0.0px 0.0px 2.0px 0px rgba(0, 0, 0, 0.05)',
};
export default tokens;
